import { PatientDTO } from './patient';
import { AppointmentDTO } from './appointment';

export class AppointmentDetailsDTO {
	constructor(
		public patient?: PatientDTO,
		public appointment?: AppointmentDTO
	) {}
}
